import EditRubricForm from 'components/Rubrics/EditRubricForm';
import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, Stack, styled, Text } from 'shell/components';

const MobileResult = ({
    result,
    setResult,
    rubricErrors,
    setRubricErrors,
    hasClickedSubmitRubric,
    validateTitle,
    validateCriteria,
    onClickEditSettings,
}) => {
    const { t } = useTranslation('assignment');

    return (
        <CustomContainer device={'mobile'}>
            <RootStack alignItems={'flex-start'} spacing={5}>
                <Stack spacing={2}>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                            {t('rubric.create-ai-rubric.review.title', 'Review Rubric')}
                        </Text>
                        <Button startIcon={<Icon kind={'edit'} />} variant={'secondary'} onClick={onClickEditSettings}>
                            {t('rubric.create-ai-rubric.review.edit-button', 'Edit')}
                        </Button>
                    </Stack>
                    <Text>
                        {t(
                            'rubric.create-ai-rubric.review.description',
                            'Please review and verify all AI-generated information for accuracy and completeness.'
                        )}
                    </Text>{' '}
                    {/* <Button sx={{ alignSelf: 'flex-start' }} startIcon={<Icon kind={'video'} />} variant={'borderless'}>
                        Best Practices for Rubric Creation
                    </Button> */}
                </Stack>
                <EditRubricForm
                    form={result}
                    setForm={setResult}
                    errors={rubricErrors}
                    setErrors={setRubricErrors}
                    hasClickedSubmit={hasClickedSubmitRubric}
                    validateTitle={validateTitle}
                    validateCriteria={validateCriteria}
                />
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        paddingBottom: theme.spacing(5),
        background: theme.palette.ensightful.shades[0],
    };
});

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

export default MobileResult;
